import LoginPage from "./LoginPage";
import ResetPasswordPage from "./ResetPasswordPage";
import VerifyEmailPage from "./VerifyEmailPage";

export default [
    {
        path: "/auth",
        name: "auth",
        component: LoginPage
    },
    {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPasswordPage
    },
    {
        path: "/verify-email",
        name: "verify-email",
        component: VerifyEmailPage
    }
]
